module.exports = function(options) {
	return navigator.serviceWorker.register(__webpack_public_path__ + "45b0ceaf4e54e698b60c.serviceworker.js", options);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/serviceworker-loader!./src/service-worker/sw.js
// module id = 2834
// module chunks = 0